import { useEffect, useState } from 'react';
import OInput from '../../../UI/FormControls/OInput';
import { formatDateBody } from '../../../../../utils/FormatDate';
import styles from './Zaglavlje.module.css';
import AutocompleteMulti from '../../../UI/AutocompleteMulti';
import useHttp from '../../../../hooks/use-http';
import { urls } from '../api/urls';
import MyButton from '../../../UI/myButton/MyButton';
import { useTranslation } from 'react-i18next';

const Zaglavlje = ({
  filterValues,
  setFilterValues,
  handlePretrazi,
  vratiGridZahteva,
  localFormValues,
}) => {
  const { getData: vratiStatuseData } = useHttp('');
  const [statusiData, setStatusiData] = useState([]);
  const { t, i18n } = useTranslation();
  // const t = (word) => t(word);

  const vratiStatuseMulti = async () => {
    const result = await vratiStatuseData({
      url: urls.GET_STATUSI_COMBO,
      method: 'POST',
      data: { metadata: i18n.language },
    });

    if (result.length > 0) {
      setStatusiData(result);
      if (result.length > 0 && Object.keys(localFormValues).length === 0) {
        // setFilterValues((curr) => {
        //   return { ...curr, statusZahteva: [result[0]] };
        // });
        vratiGridZahteva();
      } else {
        vratiGridZahteva(localFormValues.statusZahteva);
      }
    }
  };

  useEffect(() => {
    vratiStatuseMulti();
  }, [i18n.language]);

  const handleChange = (e) => {
    setFilterValues((curr) => {
      return { ...curr, [e.target.name]: e.target.value };
    });
  };
  const handleClickStatus = (e) => {
    setFilterValues((curr) => {
      return { ...curr, statusZahteva: e };
    });
  };
  return (
    <div className={styles.container}>
      <OInput
        label={t('startDate')}
        style={{ width: '200px' }}
        handleChange={handleChange}
        type="date"
        value={formatDateBody(filterValues.datumOd)}
        name="datumOd"
      />
      <OInput
        label={t('endDate')}
        style={{ width: '200px' }}
        handleChange={handleChange}
        type="date"
        value={formatDateBody(filterValues.datumDo)}
        name="datumDo"
      />
      <AutocompleteMulti
        options={statusiData}
        value={filterValues.statusZahteva}
        textProperty="vrednost"
        onChange={handleClickStatus}
        text="Status"
        style={{ maxWidth: '500px' }}
      />
      <MyButton
        onClick={handlePretrazi}
        label={t('search')}
        icon="fas fa-search"
      />
    </div>
  );
};

export default Zaglavlje;
